import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 bg-aged-cream-green relative overflow-hidden" data-id="element-273">
      <div className="container mx-auto px-4 relative z-10" data-id="element-274">
        <div className="max-w-4xl mx-auto" data-id="element-275">
          <div className="text-center mb-16" data-id="element-276">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-277">
              Aquí es donde todo cambia
            </motion.h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto mb-8" data-id="element-278">
              Existe una forma de manejar tu dinero que:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto" data-id="element-279">
              {['No es complicada', 'No te juzga', 'No te castiga', 'No te exige ser perfecta'].map((item, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-md flex items-center gap-2 justify-center" data-id="element-280">
                  <CheckCircle className="text-coral flex-shrink-0" size={20} data-id="element-281" />
                  <span className="text-slate-700 font-medium text-sm" data-id="element-282">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl mb-16" data-id="element-283">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center" data-id="element-284">
              Una forma que combina:
            </h3>
            <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-285">
              {['El método del sobre', 'La lógica real de la quincena', 'La simplicidad que hace viral TikTok', 'Los trucos prácticos que nuestras abuelas siempre usaron'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-286">
                  <CheckCircle className="text-coral flex-shrink-0" size={24} data-id="element-287" />
                  <span className="text-lg text-slate-700 font-medium" data-id="element-288">
                    {item}
                  </span>
                </li>)}
            </ul>
            <p className="text-center text-lg text-slate-600 mt-8" data-id="element-289">
              Un sistema que sí se puede mantener, incluso en meses difíciles.
            </p>
          </div>

          <div className="text-center mb-16" data-id="element-290">
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-291">
              Por eso nació El Milagro del Sobre
            </h3>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-6" data-id="element-292">
              Este ebook no nació en teoría. Nació observando un patrón real.
            </p>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-6" data-id="element-293">
              Mujeres como tú. Guardando videos. Intentándolo con ganas.
              Abandonándolo por frustración.
            </p>
            <div className="bg-aged-green p-6 rounded-xl max-w-2xl mx-auto border-l-4 border-[#f4c430] shadow-md overflow-hidden" data-id="element-294">
              <p className="text-xl font-bold text-white mb-2 relative z-10" data-id="element-295">
                El "aha moment" fue claro:
              </p>
              <p className="text-lg text-white relative z-10" data-id="element-296">
                No necesitan más motivación. Necesitan un sistema sencillo que
                no se sienta pesado.
              </p>
              <p className="text-lg font-medium text-[#f4c430] mt-4 relative z-10" data-id="element-297">
                Un sistema que funcione en la vida real.
              </p>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border-2 border-[#1a3d3d] p-1 rounded-2xl shadow-2xl" data-id="element-298">
            <div className="bg-white rounded-[14px] p-8 md:p-12 text-center" data-id="element-299">
              <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-300">
                ¿Qué es El Milagro del Sobre?
              </h3>
              <p className="text-xl text-slate-700 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-301">
                Es un ebook práctico y visual que te enseña a manejar tu dinero
                de quincena usando un sistema simple, probado y adaptable.
              </p>

              <div className="space-y-4 max-w-xl mx-auto mb-8" data-id="element-302">
                <p className="text-lg text-slate-600" data-id="element-303">
                  No necesitas ganar más.
                </p>
                <p className="text-lg text-slate-600" data-id="element-304">
                  No necesitas dejar de vivir.
                </p>
                <p className="text-lg text-slate-600" data-id="element-305">
                  No necesitas volverte experta en finanzas.
                </p>
              </div>

              <div className="bg-aged-green p-6 rounded-xl border-l-4 border-[#f4c430] max-w-xl mx-auto shadow-md overflow-hidden" data-id="element-306">
                <p className="text-2xl font-bold text-[#f4c430] relative z-10" data-id="element-307">
                  Solo necesitas separar antes de gastar.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}